import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'

const ChatsSkeleton = () => {
  return (
    <>
      <Box display="flex">
        <Skeleton sx={{ borderRadius: '50%', marginRight: '10px' }} width="40px" height="70px" />
        <Box>
          <Skeleton width="100px" height="20px" />
          <Skeleton width="130px" height="20px" />
          <Skeleton width="80px" height="20px" />
        </Box>
      </Box>
      <Box display="flex">
        <Skeleton sx={{ borderRadius: '50%', marginRight: '10px' }} width="40px" height="70px" />
        <Box>
          <Skeleton width="180px" height="20px" />
          <Skeleton width="100px" height="20px" />
          <Skeleton width="100px" height="20px" />
        </Box>
      </Box>
      <Box display="flex">
        <Skeleton sx={{ borderRadius: '50%', marginRight: '10px' }} width="40px" height="70px" />
        <Box>
          <Skeleton width="210px" height="20px" />
          <Skeleton width="200px" height="20px" />
          <Skeleton width="160px" height="20px" />
        </Box>
      </Box>
      <Box display="flex">
        <Skeleton sx={{ borderRadius: '50%', marginRight: '10px' }} width="40px" height="70px" />
        <Box>
          <Skeleton width="100px" height="20px" />
          <Skeleton width="200px" height="20px" />
          <Skeleton width="80px" height="20px" />
        </Box>
      </Box>
      <Box display="flex">
        <Skeleton sx={{ borderRadius: '50%', marginRight: '10px' }} width="40px" height="70px" />
        <Box>
          <Skeleton width="200px" height="20px" />
          <Skeleton width="90px" height="20px" />
          <Skeleton width="180px" height="20px" />
        </Box>
      </Box>
      <Box display="flex">
        <Skeleton sx={{ borderRadius: '50%', marginRight: '10px' }} width="40px" height="70px" />
        <Box>
          <Skeleton width="100px" height="20px" />
          <Skeleton width="130px" height="20px" />
          <Skeleton width="80px" height="20px" />
        </Box>
      </Box>
      <Box display="flex">
        <Skeleton sx={{ borderRadius: '50%', marginRight: '10px' }} width="40px" height="70px" />
        <Box>
          <Skeleton width="100px" height="20px" />
          <Skeleton width="200px" height="20px" />
          <Skeleton width="80px" height="20px" />
        </Box>
      </Box>
      <Box display="flex">
        <Skeleton sx={{ borderRadius: '50%', marginRight: '10px' }} width="40px" height="70px" />
        <Box>
          <Skeleton width="200px" height="20px" />
          <Skeleton width="90px" height="20px" />
          <Skeleton width="180px" height="20px" />
        </Box>
      </Box>
      <Box display="flex">
        <Skeleton sx={{ borderRadius: '50%', marginRight: '10px' }} width="40px" height="70px" />
        <Box>
          <Skeleton width="100px" height="20px" />
          <Skeleton width="130px" height="20px" />
          <Skeleton width="80px" height="20px" />
        </Box>
      </Box>
    </>
  )
}

export default ChatsSkeleton
